// import GridOptions from './GridOptions';
// import { icons } from '../../../../../shared/icons';
import { useTranslation } from 'react-i18next';

import { formatDateFromDB } from '../../../../../../../utils/FormatDate';
import MuiGrid from '../../../../../UI/MuiGrid/MuiGrid';
import Sifra from '../../../../../../../shared/components/Sifra';
import { icons } from '../../../../../../../shared/icons';
import GridOptions from './GridOptions';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import Tooltip from '@mui/material/Tooltip';

const GridProvider = ({
  data,
  handleClickNapomena,
  isLoading,
  handleClickBrojRn,
  otvoriFajlove,
}) => {
  const { t } = useTranslation();
  const columns = [
    {
      field: 'postoji',
      headerName: '',
      width: 50,
      sortable: false,
      filterable: false,
      align: 'center',
      renderCell: (params) =>
        params.row.postoji ? (
          <Tooltip title="Fajlovi su dodati" arrow>
            <CheckCircleIcon sx={{ color: 'green', fontSize: 22 }} />
          </Tooltip>
        ) : (
          <Tooltip title="Nema dodatih fajlova" arrow>
            <ErrorIcon sx={{ color: 'red', fontSize: 22 }} />
          </Tooltip>
        ),
    },
    {
      field: 'id',
      disableExport: true,
      headerName: t('options'),
      width: 70,
      sortable: false,
      filterable: false,
      renderCell: (e) => (
        <GridOptions otvoriFajlove={() => otvoriFajlove(e.row)}>
          <button className="header-options">{icons.MENU_ICON}</button>
        </GridOptions>
      ),
    },
    // ...(localStorage.idFirme === '1'
    //   ? [
    //       {
    //         field: 'nazivKupca',
    //         headerName: t('client'),
    //         width: 250,
    //       },
    //     ]
    //   : []),
    // { field: 'nazivKupca', headerName: t('client'), width: 200 },
    {
      field: 'ceoBrDok',
      headerName: 'Broj',
      width: 150,
      renderCell: (e) => (
        <Sifra
          displayValue={e.value}
          onClick={() => handleClickBrojRn(e.row)}
        />
      ),
    },
    {
      field: 'imeZaposlenog',
      headerName: 'Zaposleni',
      width: 200,
      renderCell: (e) => (
        <Sifra
          displayValue={e.value}
          onClick={() => handleClickNapomena(e.row)}
        />
      ),
    },
    {
      field: 'datum',
      headerName: t('date'),
      width: 100,
      renderCell: (e) => <span>{formatDateFromDB(e.row.datum)}</span>,
    },
    { field: 'podprojekat', headerName: t('subProject'), width: 240 },
    { field: 'napomena', headerName: 'Napomena', width: 600 },
  ];

  return (
    <div style={{ height: '69vh', width: '99%' }}>
      <MuiGrid data={data} columns={columns} loading={isLoading} />
    </div>
  );
};

export default GridProvider;
